import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormlyFieldConfig} from '@ngx-formly/core';
import {FormlyJsonschema} from '@ngx-formly/core/json-schema';
import {FormGroup} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {ContractsService} from 'src/app/services/contracts.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'aw-test-dialog',
  templateUrl: './test-dialog.component.html',
  styleUrls: ['./test-dialog.component.scss']
})
export class TestDialogComponent implements OnInit {

  test: any;
  contractID: any;
  resume: any[];
  modifiedForms: boolean = false;
  variations: any;
  response: any = null;
  checkedInterface = null;
  checkedTestName = null;
  selectedForm: FormlyFieldConfig[] = null;
  form = new FormGroup({});
  compiledForms = [];
  model = {};
  checkedIfaceBox = null;
  loading: boolean = true;
  isErrorVariationsLoaded: boolean = false;
  loadingForm: boolean = false;
  isErrorFormLoaded: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<TestDialogComponent>,
    private formlyJsonschema: FormlyJsonschema,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    private contractService: ContractsService,
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.test = this.data.test;
    this.contractID = this.data.contractID;
    this.resume = this.data.resume;
    // this.ifaces = responseIfaces.schemas;
    this.loading = true;
    this.contractService.getContractsTest(this.contractID, this.test.id).subscribe(response => {
      let res = response as any;
      this.variations = res.data.variations;
      this.loading = false;
      this.isErrorVariationsLoaded = false;
    }, error => {
       this.loading = false;
        this.isErrorVariationsLoaded = true;
    });
  }

  onRadioClick(schemaURL, testname, iface) {
    this.loadingForm = true;
    this.contractService.getGenericOutput(schemaURL).subscribe(response => {

      // response.properties = {
      //   ...response.properties,
      //   "test-select": {
      //     "type": "custom-file-select",
      //     "title": "test",
      //     "description": "test"
      //   }
      // }

      // console.log(response)
      if ('iface' in response.properties) {
        delete response.properties.iface;
      }
      Object.keys(response.properties).forEach(key => {
        if (key.endsWith("_file")) {
          response.properties[key].type = "custom-file-select";
        }
      });

      console.log(response)
      this.selectedForm = [this.formlyJsonschema.toFieldConfig(response)];
      this.checkedTestName = testname;
      this.checkedIfaceBox = iface;
      if (this.resume.length != 0) {
        for (let i = 0; i < this.resume.length; i++) {
          for (let j = 0; j < this.resume[i].forms.length; j++) {
            if (this.resume[i].forms[j].testname == testname) {
              this.model = this.resume[i].forms[j].parameters;
              this.modifiedForms = true;
            }
          }
        }
      }
      this.loadingForm = false;
      this.isErrorFormLoaded = false;
    }, error => {
        this.loadingForm = false;
        this.isErrorFormLoaded = true;
    });
  }

  onSubmit() {

    let norm_iface = this.checkedInterface

    if (this.form.valid) {

      if (!this.modifiedForms) {
        let index = this.compiledForms.findIndex((item) => item.parameters.iface === norm_iface);
        if (index < 0)
          this.compiledForms.push({
            testname: this.checkedTestName,
            ifaceBox: norm_iface,
            parameters: {
              iface: norm_iface.iname,
              ...this.model
            }
          })
        else {
          this.compiledForms[index] = {
            testname: this.checkedTestName,
            parameters: {
              iface: norm_iface,
              ...this.model
            }
          }
        }
      }

      this.checkedInterface = null;
      this.selectedForm = null;
      this.model = {};

      this._snackBar.open('Test Saved', '', {
        duration: 5000,
        verticalPosition: 'bottom',
        horizontalPosition: 'left'
      });

      this.dialogRef.close(this.compiledForms);

    }
    else
      this._snackBar.open('Test not saved', '', {
        duration: 5000,
        verticalPosition: 'bottom',
        horizontalPosition: 'left'
      });

  }

}
